import axios from "axios";
import { useConfigStore } from "../stores/config";
import z from "zod";
import { validateMyQuoteResponse } from "../entities/quote";
import { NAMES } from "../constants/companyNames";
import { getSessionId } from "@/utils";

export const sendMagicToken = async (email: string, codeChallenge: string) => {
    const config = useConfigStore();
    const response = await axios.post(`${config.apiUrl}/v1/login/passwordless`, {
        codeChallenge,
        email,
        loginType: NAMES.ANNUITIES,
    });
    return z.object({
        data: z.object({
            errors: z.array(z.object({ message: z.string() })).optional(),
            sent: z.boolean().optional(),
        }),
        status: z.number(),
    }).parse(response);
};

export const confirmMagicToken = async (email: string, codeVerifier: string, code: string) => {
    const config = useConfigStore();
    const response = await axios.post(`${config.apiUrl}/v1/login/passwordless/confirm`, {
        codeVerifier,
        email,
        code,
        loginType: NAMES.ANNUITIES,
    }, {
        validateStatus: () => true,
    });

    return { status: response.status, data: response.data };
};

export const getMyQuotes = async (email: string, token: string) => {
    const config = useConfigStore();
    const response = await axios.post(`${config.apiUrl}/v1/annuities/myquotes?sessionId=${getSessionId()}`, {
        email,
        token,
        loginType: NAMES.ANNUITIES,
        limit: 1,
        quotationsLimit: null,
        pointer: null,
        affiliate: null,
    }, {
        headers: {
            Authentication: "Bearer " + token,
        },
    });
    return z.object({
        data: z.object({
            errors: z.array(z.object({ message: z.string() })).optional(),
            response: validateMyQuoteResponse,
        }),
        status: z.number(),
    }).parse(response);
};
